export enum DrillPileType {
  Drill = 'Drill',
  Pile = 'Pile'
}